import { render, staticRenderFns } from "./upload_idcard.vue?vue&type=template&id=9aea21b2&scoped=true"
import script from "./upload_idcard.vue?vue&type=script&lang=js"
export * from "./upload_idcard.vue?vue&type=script&lang=js"
import style0 from "./upload_idcard.vue?vue&type=style&index=0&id=9aea21b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aea21b2",
  null
  
)

export default component.exports